import { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import AllMemoriesContainer from 'components/tribut/MemorySection/AllMemoriesContainer/AllMemoriesContainer';
import { getMemoryList } from 'store/memory-actions';
import Loading from 'components/UI/Loading/Loading';
import classes from './Memories.module.css';

const Memories = () => {
  const [lstMemory, setLstMemory] = useState(null);
  const [loading, setLoading] = useState(true);
  let params = useParams();
  let tributId = params.tributId ? params.tributId : 73;
  let memoryId = params.idMemory ? params.idMemory : '';
  const dispatch = useDispatch();
  const dataMemories = useSelector(state => state.memoriesData);

  useEffect(() => {
    ReactGA.initialize('G-N3MP6T91TP');
    ReactGA.pageview(`/tribut/${tributId}/memories/${memoryId}`);
  }, []);

  useEffect(() => {
    const cachedForTribut = dataMemories.byTributId?.[tributId];
    if (!cachedForTribut) {
      dispatch(getMemoryList(tributId));
    }
  }, [dispatch, tributId]);

  useEffect(() => {
    const memoriesForCurrentTribut =
      dataMemories.byTributId?.[tributId] || dataMemories.data;
    if (memoriesForCurrentTribut) {
      if (memoriesForCurrentTribut === 'error') {
        setLoading(false);
        setLstMemory('error');
      } else if (Array.isArray(memoriesForCurrentTribut)) {
        setLoading(false);
        setLstMemory(memoriesForCurrentTribut);
      }
    }
  }, [dataMemories, tributId]);

  const deleteMemoryHandler = deletedId => {
    setLstMemory(prev =>
      Array.isArray(prev)
        ? prev.filter(m => Number(m.memoryId) !== Number(deletedId))
        : prev
    );
  };

  return (
    <>
      {!loading ? (
        <>
          {lstMemory === 'error' ? (
            <p>No hay memorias</p>
          ) : (
            <section className={classes.TributContainer}>
              <AllMemoriesContainer
                memories={lstMemory}
                tributId={tributId}
                memoryView={parseInt(memoryId)}
                onDeleteMemory={deleteMemoryHandler}
              />
            </section>
          )}
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default Memories;
